<div class="page-container">
  <div class="back-button-wrapper">
    <p-button icon="pi pi-arrow-left" label="Back to Orders" routerLink="/orders" severity="secondary"></p-button>
  </div>

  @if (order(); as order) {
    <div class="header-with-status">
      <h1 class="order-title">
        {{ order.orderId }}
        <p-tag [value]="order.status" severity="info"></p-tag>
      </h1>
    </div>

    <div class="order-content">
      <p-card header="Order Details">
        <div class="detail-row">
          <strong>Group ID:</strong>
          <span>{{ order.groupId ?? '—' }}</span>
        </div>
        <div class="detail-row">
          <strong>Acting User ID:</strong>
          <span>{{ order.actingUserId ?? '—' }}</span>
        </div>
        <div class="detail-row">
          <strong>Type:</strong>
          <span>{{ order.orderType }}</span>
        </div>
        <div class="detail-row">
          <strong>Amount Paid:</strong>
          <span>{{ order.amountPaid != null ? (order.amountPaid | currency) : '—' }}</span>
        </div>
        <div class="detail-row">
          <strong>Created:</strong>
          <span>{{ order.createdOn | date: 'medium' }}</span>
        </div>
        <div class="detail-row">
          <strong>Modified:</strong>
          <span>{{ order.modifiedOn | date: 'medium' }}</span>
        </div>
      </p-card>

      <p-card header="Line Items ({{ order.lineItems.length }})">
        <p-table dataKey="lineItemId" [value]="order.lineItems">
          <ng-template pTemplate="header">
            <tr>
              <th>Name</th>
              <th>Type</th>
              <th>Quantity</th>
              <th>Consumer</th>
              <th>Assignee</th>
              <th>Establishment ID</th>
            </tr>
          </ng-template>

          <ng-template let-item pTemplate="body">
            <tr>
              <td>{{ item.name }}</td>
              <td>
                <p-tag [value]="item.lineItemType" severity="secondary"></p-tag>
              </td>
              <td>{{ item.quantity }}</td>
              <td>{{ item.consumer ?? '—' }}</td>
              <td>{{ item.assignee ?? '—' }}</td>
              <td>{{ item.establishmentId ?? '—' }}</td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td class="empty-message-cell" colspan="6">
                <p-message severity="info">No line items for this order.</p-message>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-card>
    </div>
  } @else if (isLoading()) {
    <div class="loading-state">
      <p-skeleton width="28rem" height="2.5rem"></p-skeleton>
      <p-skeleton width="100%" height="10rem" class="mt-4"></p-skeleton>
      <p-skeleton width="100%" height="14rem" class="mt-4"></p-skeleton>
    </div>
  } @else {
    <div class="not-found">
      <p-message severity="warn">Order not found. It may not have been loaded yet — go back to the list and try again.</p-message>
      <p-button icon="pi pi-arrow-left" label="Back to Orders" routerLink="/orders" severity="secondary"></p-button>
    </div>
  }
</div>
